import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getOpenThermStateName, OpenThermVariableName } from 'openTherm';
import { TableCell, TableRow } from '@mui/material';
import { formatTemp } from 'utils';
export const OTHeatingFlags = new Set([
    OpenThermVariableName.cs,
    OpenThermVariableName.bt,
    OpenThermVariableName.rwt,
    OpenThermVariableName.rp,
    OpenThermVariableName.rt,
    OpenThermVariableName.ot,
]);
export function OTHeatingGroup(props) {
    const { ot_value } = props;
    if (ot_value == null) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(TableRow, { color: "secondary", children: _jsx(TableCell, { variant: "head", colSpan: 2, align: "center", children: "\u041E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u0435" }) }), [...ot_value].map(([flag, value]) => (_jsxs(TableRow, { hover: true, children: [_jsx(TableCell, { variant: "head", children: getOpenThermStateName(flag, 'ru') }), _jsx(TableCell, { children: formatTemp(value) })] }, flag)))] }));
}
